export const regions = [
  {
    region: 'Вінницька область',
    cities: ['Вінниця', 'Гайсин', 'Жмеринка', 'Могилів-Подільський', 'Тульчин', 'Хмільник'],
  },
  {
    region: 'Волинська область',
    cities: ['Луцьк', 'Володимир', 'Камінь-Каширський', 'Ковель'],
  },
  {
    region: 'Дніпропетровська область',
    cities: ['Дніпро', 'Камʼянське', 'Кривий Ріг', 'Нікополь', 'Новомосковськ', 'Павлоград', 'Синельникове'],
  },
  {
    region: 'Донецька область',
    cities: ['Донецьк', 'Бахмут', 'Волноваха', 'Горлівка', 'Кальміуське', 'Краматорськ', 'Маріуполь', 'Покровськ'],
  },
  {
    region: 'Житомирська область',
    cities: ['Житомир', 'Бердичів', 'Коростень', 'Звягель'],
  },
  {
    region: 'Закарпатська область',
    cities: ['Ужгород', 'Берегове', 'Мукачево', 'Рахів', 'Тячів', 'Хуст'],
  },
  {
    region: 'Запорізька область',
    cities: ['Запоріжжя', 'Бердянськ', 'Василівка', 'Мелітополь', 'Пологи'],
  },
  {
    region: 'Івано-Франківська область',
    cities: ['Івано-Франківськ', 'Верховина', 'Калуш', 'Коломия', 'Косів', 'Надвірна'],
  },
  {
    region: 'Київська область',
    cities: ['Київ', 'Біла церква', 'Бориспіль', 'Бровари', 'Буча', 'Вишгород', 'Обухів', 'Фастів'],
  },
  {
    region: 'Кіровоградська область',
    cities: ['Кропивницький', 'Голованівськ', 'Новоукраїнка', 'Олександрія'],
  },
  {
    region: 'Луганська область',
    cities: ['Луганськ', 'Алчевськ', 'Довжанськ', 'Ровеньки', 'Сватове', 'Сєвєродонецьк', 'Старобільськ', 'Новоайдар'],
  },
  {
    region: 'Львівська область',
    cities: ['Львів', 'Дорогобич', 'Золочів', 'Самбір', 'Стрий', 'Червоногрда', 'Яворів'],
  },
  {
    region: 'Миколаївська область',
    cities: ['Миколаїв', 'Баштанка', 'Вознесенськ', 'Первомайськ'],
  },
  {
    region: 'Одеська область',
    cities: ['Одеса', 'Березівка', 'Білгород-Днестровський', 'Болград', 'Ізмаїл', 'Подільськ', 'Роздільна'],
  },
  {
    region: 'Полтавська область',
    cities: ['Полтава', 'Кременчук', 'Лубни', 'Миргород'],
  },
  {
    region: 'Рівненська область',
    cities: ['Рівне', 'Вараш', 'Дубно', 'Сарни'],
  },
  {
    region: 'Сумська область',
    cities: ['Суми', 'Конотоп', 'Охтирка', 'Ромни', 'Шостка'],
  },
  {
    region: 'Тернопільська область',
    cities: ['Тернопіль', 'Кременець', 'Чортків'],
  },
  {
    region: 'Харківська область',
    cities: ['Харків', 'Берестин', 'Богодухів', 'Ізюм', 'Купʼянськ', 'Лозова', 'Чугуїв'],
  },
  {
    region: 'Херсонська область',
    cities: ['Херсон', 'Берислав', 'Генічеськ', 'Каховка', 'Скадовськ'],
  },
  {
    region: 'Хмельницька область',
    cities: ['Хмельницький', 'Камʼянець-Подільський', 'Шепетівка'],
  },
  {
    region: 'Черкаська область',
    cities: ['Черкаси', 'Звенигородка', 'Золотоноша', 'Умань'],
  },
  {
    region: 'Чернівецька область',
    cities: ['Чернівці', 'Вижниця', 'Кельминці'],
  },
  {
    region: 'Чернігівська область',
    cities: ['Чернігів', 'Корюківка', 'Ніжин', 'Новгород-Сіверський', 'Прилуки'],
  },
];
